import React from 'react';
import TariefDetailsNode from '../customNodes/TariefDetailsNode';

const TariefNode = ({ rights, t, disabled, hotel, events, css }) => {
    return (
        <>
            <div id="tarief_list" className={css.regionsgrid}>
                <div id="headertabled" className={css.ratestableheader}><p id="type">{t('Tarieflijstvoor')}</p></div>&nbsp;
            </div>
            <TariefDetailsNode rights={rights} t={t} disabled={true} hotel={hotel} tarief={null} events={{setErrorMessage:events.setErrorMessage}} css={css}/>
        </>
    );
}


export default TariefNode;
